export default __webpack_public_path__ + "static/media/82.2ffd8e8f.png";